<template>
  <section class="sec-product-home">
    <div :class="['line-bee-top', { active: showTopImage }]" ref="topImage">
      <img
        class="line-bee-top__image"
        src="../../public/image/bee-line-rev.png"
      />
    </div>
    <header class="sec-home-titr" ref="titr">
      <h1 class="sec-home-titr__title" :class="{ active: showProductTitle }">
        محصولات ما
      </h1>
    </header>
    <main class="product-slider">
      <slider-part :breakpoint="breakpoints" :datas="productListLength">
        <template v-slot:default="slotProps">
          <card-part :carddata="slotProps.slidercontent"> </card-part>
        </template>
      </slider-part>
    </main>
    <div class="sec-product-home-link">
      <router-link to="/home" class="base-btn-2"
        >همه ی محصولات<i class="fas fa-arrow-right"></i
      ></router-link>
    </div>
    <div
      :class="['line-bee-bottom', { active: showBottomImage }]"
      ref="bottomImage"
    >
      <img
        class="line-bee-bottom__image"
        src="../../public/image/bee-line.png"
      />
    </div>
  </section>
</template>

<script>
import sliderPart from "./Slider.vue";

export default {
  components: {
    sliderPart,
  },
  data() {
    return {
      breakpoints:{
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 20,
        // when window width is >= 750px
        750: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          spaceBetween: 20,
        },

        // when window width is >= 1150px
        1150: {
          slidesPerView: 3,
          spaceBetween: 20,
          slidesPerGroup: 3,
        },
      },
      productListLength: null,
      showProductTitle: false,
      showTopImage: false,
      showBottomImage: false,
    };
  },
  mounted() {
    this.calcCardSlider();
    window.addEventListener("resize", () => {
      this.calcCardSlider();
    });
    let topImage = this.$refs.topImage;
    let bottomImage = this.$refs.bottomImage;
    let titr = this.$refs.titr;
    let vh = (window.innerHeight * 4) / 5;
    let vhImage = (window.innerHeight * 5) / 6;
    window.addEventListener("scroll", () => {
      let topOfTitle = titr.getBoundingClientRect().top;
      let topOfTopImage = topImage.getBoundingClientRect().top;
      let bottomOfBottomImage = bottomImage.getBoundingClientRect().top;

      if (topOfTitle < vh) {
        this.showProductTitle = true;
      }
      if(topOfTopImage<vhImage){
        this.showTopImage=true
      }
      if(bottomOfBottomImage<vhImage){
        this.showBottomImage=true
      }
    });
  },
  methods: {
    calcCardSlider() {
      if (window.innerWidth < 750) {
        this.productListLength = this.$store.getters.getProductHomeCard(3);
      } else if (window.innerWidth < 1150) {
        this.productListLength = this.$store.getters.getProductHomeCard(4);
      } else {
        this.productListLength = this.$store.getters.getProductHomeCard(6);
      }
    },
  },

};
</script>

<style></style>
